export default "<div class=\"circle\">\n  <img class=\"circle__picture\" src=\"{{ src }}\">\n  <div class=\"circle__background\"></div>\n</div>"